import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  AfterViewInit,
  ViewChild,
  inject,
  signal,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
//import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { MatSort } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router, RouterLinkWithHref } from "@angular/router";
import {
  MatDialogModule,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
import { MsalService } from "@azure/msal-angular";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { HttpParams } from "@angular/common/http";
import { RouterModule } from "@angular/router"; // 必須
import dayjs from "dayjs";

// Services
import { StoreUserService } from '@app/core/state/store-user.service';
import { ListSectionGroupsService } from "../../../data/section-group/list-section-groups.service";
import { DatabaseCacheService } from "../../../data/cache/database-cache.service";
import { SystemAdminNavComponent } from "../system-admin-nav/system-admin-nav.component";
import { SectionGroupAdminNavComponent } from "../../admin-section-group/section-group-admin-nav/section-group-admin-nav.component";
import { GetParameterService } from "../../../data/record/get-parameter.service";
import { ListSectionMonthlySummariesService } from "../../../data/section/list-section-monthly-summaries.service";
import { ListSectionGroupMonthlySummariesService } from "../../../data/section-group/list-section-group-monthly-summaries.service";

import { UserDataTemplateListComponent } from "../user-data-template-list/user-data-template-list.component";

// For Dialog view
import { tr } from "date-fns/locale";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";
import { MONTHLY_SUMMARIES_LIST_I18N } from "./monthly-summaries-list.i18n";

@Component({
  selector: "app-monthly-summaries-list",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./monthly-summaries-list.component.html",
  styleUrls: ["./monthly-summaries-list.component.scss"],
  imports: [...SHARED_IMPORTS, PageHeaderComponent],
})
export class MonthlySummariesListComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);

  // Loading state
  isLoading = signal(true);

  // i18n定数（型安全・IDE補完対応）
  protected readonly i18n = MONTHLY_SUMMARIES_LIST_I18N;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("menuTrigger") menuTrigger: MatMenuTrigger;

  loginUserId = "";
  filter = ""; //table filtering

  currentUrl = "";

  year: number;
  month: number;
  yearOfNextMonth: number;
  monthOfNextMonth: number;
  yearOfPrevMonth: number;
  monthOfPrevMonth: number;
  noNextMonth: boolean;

  sectionGroupId;
  sectionId;

  subpageTitle;

  fixed;

  basePath;

  sectionGroupMonthlySummaries: any[] = [];
  displayedColumns = [
    "name",
    "dataUsage",
    "quotaModel",
    "status",
    "numOfStaffs",
    "numOfContributors",
    "numOfUsers",
    "expand",
  ];

  accountStatus: { [key: string]: string } = {
    OPEN: MONTHLY_SUMMARIES_LIST_I18N.status.active,
    CLOSE: MONTHLY_SUMMARIES_LIST_I18N.status.inactive,
  };

  dataSource: MatTableDataSource<SectionGroupMonthlySummary>;

  constructor(
    public storeUser: StoreUserService,
    private listSectionGroupsService: ListSectionGroupsService,
    private route: ActivatedRoute,
    private router: Router,
    private msalService: MsalService,
    public dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private iconRegistry: MatIconRegistry,
    public common: DatabaseCacheService,
    // private saNav : SystemAdminNavComponent,
    // private sgaNav :SectionGroupAdminNavComponent,
    private getParameterService: GetParameterService,
    private listSectionMonthlySummariesService: ListSectionMonthlySummariesService,
    private listSectionGroupMonthlySummariesService: ListSectionGroupMonthlySummariesService,
  ) {
    let user = this.msalService.instance.getActiveAccount();
    this.loginUserId = user.idTokenClaims["sub"];

    // カスタムSVG iconの呼び出し
    this.iconRegistry.addSvgIcon(
      "icon_staff", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_staff.svg",
      ), //必ずサニタイザーを利用して取得する。
    );

    this.iconRegistry.addSvgIcon(
      "icon_setting", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_setting.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-close", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-close.svg",
      ),
    );

    this.iconRegistry.addSvgIcon(
      "icon_account-open", // ここで名前を指定
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        "./assets/icon_account-open.svg",
      ),
    );
  }

  ngOnInit() {
    // section
    this.common.parametersUpdated
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((noData) => {});

    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
      const urlSegments = this.router.url.split("/");
      this.basePath = urlSegments.slice(0, -2); // `year` / `month` を除いた部分を取得（最後の2つのセグメントを削除）

      this.sectionGroupId = params.get("sectionGroupId");
      this.sectionId = params.get("sectionId");

      this.year = parseInt(params.get("year") || "2000", 10);
      this.month = parseInt(params.get("month") || "1", 10);
      this.setYearMonth(this.year, this.month);
      this.listMonthlySummaries(
        this.sectionGroupId,
        this.sectionId,
        this.year,
        this.month,
      );

    });
  }

  setYearMonth(year, month) {
    this.yearOfPrevMonth = this.year;
    this.monthOfPrevMonth = this.month - 1;
    if (this.monthOfPrevMonth == 0) {
      this.yearOfPrevMonth--;
      this.monthOfPrevMonth = 12;
    }

    this.yearOfNextMonth = this.year;
    this.monthOfNextMonth = this.month + 1;
    if (this.monthOfNextMonth == 13) {
      this.yearOfNextMonth++;
      this.monthOfNextMonth = 1;
      this.noNextMonth = false;

      const now = dayjs();
      const maxYear = now.year();
      const maxMonth = now.month() + 1;
      if (this.year == maxYear && this.month == maxMonth) {
        this.noNextMonth = true;
      }
    }
  }

  getRouterLink(basePath, year, month) {
    return [...basePath, year, month];
  }

  refreshData() {
    this.listMonthlySummaries(
      this.sectionGroupId,
      this.sectionId,
      this.year,
      this.month,
    );
  }

  ngAfterViewInit(): void {}

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  listMonthlySummaries(sectionGroupId, sectionId, year, month) {
    this.isLoading.set(true);
    this.fixed = this.i18n.status.loading;

    let params: HttpParams = new HttpParams()
      .set("fiscalYearFrom", year)
      .set("fiscalMonthFrom", month)
      .set("fiscalYearTo", year)
      .set("fiscalMonthTo", month);

    this.subpageTitle = this.i18n.subpageTitle.systemAdmin;
    if (sectionGroupId != null) {
      params = params.set("sectionGroupIds", sectionGroupId);
      this.subpageTitle = this.i18n.subpageTitle.sectionGroupAdmin;
    }

    if (sectionId != null) {
      params = params.set("sectionIds", sectionId);
      this.subpageTitle = this.i18n.subpageTitle.sectionAdmin;
    }

    let disp = false;
    if (this.sectionGroupId != null || this.sectionId != null) {
      disp = true;
    }

    var listFunc =
      this.listSectionGroupMonthlySummariesService.listSectionGroupMonthlySummaries.bind(
        this.listSectionGroupMonthlySummariesService,
      );
    if (sectionId != null) {
      listFunc =
        this.listSectionMonthlySummariesService.listSectionMonthlySummaries.bind(
          this.listSectionMonthlySummariesService,
        );
    }

    listFunc(params)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
      (res) => {

        var resSummaries = res as Array<any>;

        this.sectionGroupMonthlySummaries = [];

        this.fixed = this.i18n.status.noData;

        for (var i = 0; i < resSummaries.length; i++) {
          let resSummary = resSummaries[i];

          this.fixed =
            resSummary.sectionGroup.status == "FIXED"
              ? this.i18n.status.fixed
              : this.i18n.status.unfixed;

          let sgId = resSummary.sectionGroup.sectionGroupId;
          let sgName = resSummary.sectionGroup.sectionGroupName;
          // let sgs = this.common.getSectionGroupDocuments();
          // let sg = this.common.getSectionGroupDocuments().find(s => s.id == sgId);
          // let sgName = this.common.getSectionGroupDocuments().find(s => s.id == sgId)?.name;
          let dataUsedTotalGB =
            resSummary.sectionGroup.dataUsedTotalBytes / 1024 / 1024 / 1024;
          let dataUsedSharedGB =
            resSummary.sectionGroup.dataUsedSharedBytes / 1024 / 1024 / 1024;
          let usageStatus =
            dataUsedSharedGB > resSummary.sectionGroup.monthlyQuotaGB
              ? this.i18n.status.exceeded
              : "";
          let sgSummaryTemp: SectionGroupMonthlySummary = {
            type: "sectionGroup",
            disp: disp,

            id: resSummary.id,
            sectionGroupId: sgId,
            sectionGroupName: sgName,

            fiscalYear: resSummary.sectionGroup.fiscalYear,
            fiscalMonth: resSummary.sectionGroup.fiscalMonth,

            quotaModel: null,
            monthlyQuotaGB: resSummary.sectionGroup.monthlyQuotaGB,
            dataUsedTotalBytes: resSummary.sectionGroup.dataUsedTotalBytes,
            dataUsedTotalGB: dataUsedTotalGB,
            dataUsedSharedBytes: resSummary.sectionGroup.dataUsedSharedBytes,
            dataUsedSharedGB: dataUsedSharedGB,

            usageStatus: usageStatus,

            lastModifiedAt: resSummary.sectionGroup?.common?.lastModifiedAt,
            lastModifiedBy: resSummary.sectionGroup?.common?.lastModifiedBy,

            sectionMonthlySummaries: [],
          };

          this.sectionGroupMonthlySummaries.push(sgSummaryTemp);

          let sectionSummaries = resSummary.sections;
          let anySectionDataOverUse = false;
          for (var j = 0; j < sectionSummaries.length; j++) {
            let secSummary = sectionSummaries[j];

            let dataUsedGB = secSummary.dataUsedBytes / 1024 / 1024 / 1024;
            let quotaModel = secSummary.sectionQuotaModel;
            let dataOverUse =
              dataUsedGB > secSummary.monthlyQuotaGB &&
              quotaModel == "DEDICATED";
            let usageStatus = dataOverUse ? this.i18n.status.exceeded : "";
            anySectionDataOverUse ||= dataOverUse;

            let secSummaryTemp: SectionMonthlySummary = {
              type: "section",
              disp: disp,

              id: secSummary.id,
              sectionId: secSummary.sectionId,
              sectionName: secSummary.sectionName,
              sectionGroupId: sgId,

              fiscalYear: secSummary.fiscalYear,
              fiscalMonth: secSummary.fiscalMonth,

              quotaModel: secSummary.sectionQuotaModel,
              monthlyQuotaGB: secSummary.monthlyQuotaGB,
              dataUsedBytes: secSummary.dataUsedBytes,
              dataUsedGB: dataUsedGB,
              monthlyQuotaDesc:
                secSummary.sectionQuotaModel == "SHARED"
                  ? this.common.quotaModels.find((q) => q.code == "SHARED").desc
                  : `${secSummary.monthlyQuotaGB} GB`,

              usageStatus: usageStatus,

              numOfUsers: secSummary.numOfUsers,
              numOfStaffs: secSummary.numOfStaffs,
              numOfContributors: secSummary.numOfContributors,
              numOfSupervisores: secSummary.numOfSupervisores,

              lastModifiedAt: secSummary.lastModifiedAt,
              lastModifiedBy: secSummary.lastModifiedBy,
            };

            this.sectionGroupMonthlySummaries.push(secSummaryTemp);
          }

          if (anySectionDataOverUse) {
            sgSummaryTemp.usageStatus = this.i18n.status.exceeded;
          }
        }

        this.setFilteredData();
        this.isLoading.set(false);
        this.cdr.markForCheck();
      },
      (error) => {
        this.isLoading.set(false);
        this.cdr.markForCheck();
      },
    );
  }

  expandCollapse(row) {
    if (row.type != "sectionGroup") {
      return;
    }

    let sectionGroupId = row.sectionGroupId;
    let disp = !row.disp;
    this.sectionGroupMonthlySummaries
      .filter((s) => s.sectionGroupId == sectionGroupId)
      .forEach((s) => (s.disp = disp));

    this.setFilteredData();
  }

  setFilteredData() {
    let filtered = this.sectionGroupMonthlySummaries.filter(
      (s) => s.disp || s.type == "sectionGroup",
    );
    this.dataSource = new MatTableDataSource(filtered);
  }

  getUsageStatusIcon(usageStatus: string): string {
    return usageStatus === this.i18n.status.exceeded ? "cloud_alert" : "check_circle";
  }
}

export interface SectionGroupMonthlySummary {
  type: string;
  disp: boolean;

  id: string;
  sectionGroupName: string;
  sectionGroupId: string;

  fiscalYear: number;
  fiscalMonth: number;

  quotaModel: string; //sectionと同じテーブルに表示するために必要。常にnullにする

  monthlyQuotaGB: number;
  dataUsedTotalBytes: number;
  dataUsedTotalGB: number;
  dataUsedSharedBytes: number;
  dataUsedSharedGB: number;

  usageStatus: string;

  lastModifiedAt: string;
  lastModifiedBy: string;

  sectionMonthlySummaries: SectionMonthlySummary[];
}

export interface SectionMonthlySummary {
  type: string;
  disp: boolean;

  id: string;
  sectionName: string;
  sectionId: string;
  sectionGroupId: string;

  fiscalYear: number;
  fiscalMonth: number;

  quotaModel: string;
  monthlyQuotaGB: number;
  monthlyQuotaDesc: string;
  dataUsedBytes: number;
  dataUsedGB: number;

  usageStatus: string;

  numOfUsers: number;
  numOfStaffs: number;
  numOfContributors: number;
  numOfSupervisores: number;

  lastModifiedAt: string;
  lastModifiedBy: string;
}
